import {Payment} from "../services/order/paymentHistory"

export const RESTRICTED_PAYMENT: Record<string, {displayMethod: string}> = {
	invoice: {displayMethod: "Mondu"},
	klarna: {displayMethod: "Klarna"},
	directdebit: {displayMethod: "Mondu"},
}

export const CREDIT_DISABLED_TOOLTIP =
	"Credits cannot be issued for Klarna/Mondu transactions. Please follow the refund process."

export function getDisplayPaymentMethod(payment: Payment): string {
	const paymentMethod = payment.paymentMethodInfo.paymentMethod
	if (payment.orderNumber?.startsWith("VCS") && paymentMethod === "PayOnBillingAccount") {
		if (payment.paymentTiming === "PrePaid") return "Company Card"
		if (payment.paymentTiming === "PostPaid") return "Company Invoice"
		return paymentMethod
	}
	return RESTRICTED_PAYMENT[paymentMethod]?.displayMethod ?? paymentMethod
}

export function isCreditDisabled(paymentMethod: string): boolean {
	return paymentMethod in RESTRICTED_PAYMENT
}
